








































































































































































































































































































































































































import {Component, Vue, Prop} from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import PatientList from "@/components/PatientList.vue";
import BatchPrinting from "@/components/batch-printing.vue";
import SinglePrinting from "@/components/single-printing.vue";

import {getCurrentTime} from "@/utils/base";
import {GetKey} from "@/utils/base";
import {
  GetNewsTems, GetContentList, DelContent,
  GetTemList, PostCepingContent, EditContent,
  GetPatientLatestResult
} from "@/request/common";
import {GetExeImg} from "@/components/template-transfer-pc/template/request";
import Report from "@/components/template-transfer-pc/report/report.vue";
import Empty from "@/components/empty.vue";
import Jiancha from "./components/jiancha.vue";
import EditZhuanbing from "./zhuanbing/edit-zhuanbing.vue";
import {initData} from "@/components/template-transfer-pc/template/common";
import {HomeCepingScanListener} from "@/utils/home-ceping-scan-listener";
import {CepingScanPayload} from "@/utils/ceping-scan";
import {syncPatientAndCreateCheckByScan} from "@/utils/scan-patient-check-service";
import {autoCreateTizhiContentByScanAnswer} from "@/utils/scan-auto-tizhi-service";

@Component({
  components: {
    Empty,
    MainHeader,
    PatientList,
    BatchPrinting,
    SinglePrinting,
    Report,
    Jiancha,
    EditZhuanbing,
  },
})
export default class Name extends Vue {
  private newstData: any = [];
  private elseList: any = [];
  private reportList: any = [];
  private reportData: any = [];
  private ifEdit: any = false;
  private ifShowBatchPrinting: any = false;
  private ifShowSinglePrinting: any = false;

  private ifShowJiancha: any = false;
  private ifShowElse: any = false;
  private ifShowZhuanbing: any = false;
  private jianchaQuery: any = {};
  private jianchaList: any = [];
  private elseData: any = [];
  private cTab: any = {name: "首页"};
  private bannerWidth: string = "0px";
  private bannerHeight: string = "0px";
  private ifShowTip: any = false;
  private jianChaStartTime: any;
  private jianChaEndTime: any;
  private currentJianchaId: string = "";
  private wangZhengCount = 1;
  private maiZhengCount = 6;
  private lampValue = false;
  private homeScanListener: HomeCepingScanListener | null = null;

  private get user() {
    return this.$store.state.user;
  }

  private get patient() {
    return this.$store.state.patient;
  }

  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private mode3Data: any = {
    舌: null,
    面: null,
    舌下: null,
    脉: null,
  }

  private get finalBannerList() {
    if (this.systemInfo.customBanners && this.systemInfo.customBanners.length > 0) {
      return this.systemInfo.customBanners;
    }
    return [
      "/common/1.jpg",
      "/common/2.jpg"
    ];
  }

  private async getPatientLatestResultData() {
    const params: any = {
      params: {
        patient_id: this.patient.id,
      },
    };
    const res = await GetPatientLatestResult(this, params);
    console.log(res);
    let ids: any = [];
    res.data.forEach((ele: any) => {
      ids.push(ele.content_id);
    });
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify(ids),
        ifShowFengmian: "是",
      },
    });
    console.log('最新报告');
    console.log(ids);
  }

  private async saveReportData() {
    console.log('saveData');
    console.log(this.reportData);
    const params: any = {
      report: this.reportData.report,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const res = await EditContent(this, this.reportData.id, params, loading);
    console.log('保存结果');
    console.log(res);
    loading.close();
    this.$message.success("保存成功！");
    this.getData();
    this.ifEdit = false;
  }

  private async getMode3Data() {
    console.log('getMode3Data');
    // 需要调取接口拿数据 
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: "四诊客观化数据",
      },
    };
    const newstData = await GetNewsTems(this, params);
    //从这里封装一个方法，根据name获取数据
    this.mode3Data['舌'] = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌');
    this.mode3Data['面'] = await this.getCurrentData(newstData.data['四诊客观化数据'], '面');
    this.mode3Data['舌下'] = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌下');
    this.mode3Data['脉'] = await this.getCurrentData(newstData.data['四诊客观化数据'], '脉');
    this.$forceUpdate();
  }

  private async getCurrentData(arr: any, name: any) {
    let item;
    if (name === "舌") {
      item = arr.find((item: any) => item.name.startsWith("舌") && !item.name.startsWith("舌下"));
    } else if (name === "舌下") {
      item = arr.find((item: any) => item.name.startsWith("舌下"));
    } else {
      item = arr.find((item: any) => item.name.includes(name));
    }
    if (item && item.content_id && item.collect_time) {
      const today = getCurrentTime("yyyy-MM-dd");
      if (item.collect_time.startsWith(today)) {
        return item;
      }
    }
    return null;
  }

  private checkedJianChaListIsEmpty() {
    if (this.jianChaListIsEmpty()) {
      this.$confirm("请先新建检查", "提示", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.openJiancha(null)
      })
      return true
    }
    return false
  }

  //获取最近一次新建检查下面的全部报告
  private getLastJianChaAllReportList(startTime: string, endTime: string) {
    const params: any = {
      params: {
        page: 1,
        patient_id: this.patient.id,
        limit: 2000,
        has_related_type: true,
        has_report_type: true,
      },
    };

    GetContentList(this, params).then((res: any) => {
      let rawData = res.data;
      this.wangZhengCount = 1
      this.maiZhengCount = 6
      if (startTime && endTime) {
        const start = new Date(startTime);
        const end = new Date(endTime);
        let data = rawData.filter((item: any) => {
          if (!item.create_datetime) return false;
          const createTime = new Date(item.create_datetime);
          return createTime >= start && createTime <= end;
        });
        if (data != null) {
          this.wangZhengCount = data.filter((t: { template: { name: string } }) =>
              ['舌诊采集', '面诊采集', '舌下脉络采集'].includes(t.template.name)
          ).length;
          this.maiZhengCount = data.filter((t: { template: { name: string } }) =>
              ['脉诊采集'].includes(t.template.name)
          ).length;
        } else {
          this.wangZhengCount = 0
          this.maiZhengCount = 0
        }

      }

    });
  }

  private jianChaListIsEmpty() {
    if (this.jianchaList.length <= 0) {
      return true
    }
    return false
  }

  private async goWangzhen() {
    if (this.checkedJianChaListIsEmpty()) {
      return
    }
    if (this.wangZhengCount > 0) {
      return
    }
    if (this.lampValue == true) {
      window.electronMyAPI.changeLight("紫外光-OFF");
      this.lampValue = false
    }

    let type = 'real'; // mock 模拟数据,real 真实数据
    if (type == 'real') {
      this.ifShowTip = true;
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const uid = Date.now() + "_" + this.patient.id;
      const resultStr: any = await window.electronMyAPI.uploadWangzhen(uid);
      loading.close();
      console.log('exe返回值')
      console.log(resultStr);
      if (resultStr && resultStr.includes('success')) {
        const res: any = {
          舌: {
            "url": resultStr.split(',')[1] + resultStr.split(',')[2],
            "file_url": resultStr.split(',')[1] + resultStr.split(',')[2],
            "description": null,
          },
          舌下: {
            "url": resultStr.split(',')[1] + resultStr.split(',')[3],
            "file_url": resultStr.split(',')[1] + resultStr.split(',')[3],
            "description": null,
          },
          面: {
            "url": resultStr.split(',')[1] + resultStr.split(',')[4],
            "file_url": resultStr.split(',')[1] + resultStr.split(',')[4],
            "description": null,
          },
        }
        if (res['舌'] && res['舌'].url) {
          await this.saveData('舌', res['舌']);
        }
        if (res['面'] && res['面'].url) {
          await this.saveData('面', res['面']);
        }
        if (res['舌下'] && res['舌下'].url) {
          await this.saveData('舌下', res['舌下']);
        }
        this.getMode3Data();
        this.goRefreshTopData();
        this.getJianchaList();
        this.ifShowTip = false;
      } else {
        this.ifShowTip = false;
        this.$confirm("对不起，采集失败，请重新采集！", "望诊采集", {
          customClass: "commonConfirm",
          confirmButtonClass: "iconfont icon-anniu4 confirmSure",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
          confirmButtonText: "重新采集",
          cancelButtonText: "返回",
        })
            .then(() => {
              this.goWangzhen();
            })
      }
    } else {
      const res = {
        舌: {
          "id": 3214,
          "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125322.jpg",
          "name": "125322.jpg",
          "size": "60420",
          "engine": "oss",
          "md5sum": "58df3c1df9854a1eaf83f171f52d3c41",
          "creator": 39,
          "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125322.jpg",
          "modifier": "39",
          "mime_type": "image/jpeg",
          "description": null,
          "creator_name": "河南四诊",
          "modifier_name": "河南四诊",
          "dept_belong_id": 16,
          "create_datetime": "2025-07-16 09:47:38",
          "update_datetime": "2025-07-16 09:47:38"
        },
        面: {
          "id": 3217,
          "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/20230914155607.png",
          "name": "20230914155607.png",
          "size": "405132",
          "engine": "oss",
          "md5sum": "e19c6b987a948abee98fdbd90d4423fe",
          "creator": 39,
          "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/20230914155607.png",
          "modifier": "39",
          "mime_type": "image/png",
          "description": null,
          "creator_name": "河南四诊",
          "modifier_name": "河南四诊",
          "dept_belong_id": 16,
          "create_datetime": "2025-07-16 09:48:41",
          "update_datetime": "2025-07-16 09:48:41"
        },
        舌下: {
          "id": 3218,
          "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125327.jpg",
          "name": "125327.jpg",
          "size": "77935",
          "engine": "oss",
          "md5sum": "6ce46c704f01d8c39468614914ee2b4d",
          "creator": 39,
          "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125327.jpg",
          "modifier": "39",
          "mime_type": "image/jpeg",
          "description": null,
          "creator_name": "河南四诊",
          "modifier_name": "河南四诊",
          "dept_belong_id": 16,
          "create_datetime": "2025-07-16 09:49:32",
          "update_datetime": "2025-07-16 09:49:32"
        },
      }
      // 弹出中间弹框
      this.$confirm("是否在设备上采集完成？", "望诊采集", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        confirmButtonText: "采集完成",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        cancelButtonText: "取消",
      }).then(async () => {
        this.ifShowTip = true;
        if (res['舌']) {
          await this.saveData('舌', res['舌']);
        }
        if (res['面']) {
          await this.saveData('面', res['面']);
        }
        if (res['舌下']) {
          await this.saveData('舌下', res['舌下']);
        }
        this.getMode3Data();
        this.goRefreshTopData();
        this.getJianchaList();
        this.ifShowTip = false;
      });
    }


  }

  private async saveData(type: any, img: any) {
    console.log('saveData');
    console.log(type);
    console.log(img);
    let res: any = {};
    // 直接从 API 获取最新数据，而不是依赖可能过时的 this.newstData
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: "四诊客观化数据",
      },
    };
    const newstDataRes = await GetNewsTems(this, params);
    const arr = newstDataRes.data["四诊客观化数据"];
    console.log('arr');
    console.log(arr);
    let item: any = {};
    if (type === "舌") {
      item = arr.find((item: any) => item.name.startsWith("舌") && !item.name.startsWith("舌下"));
    } else if (type === "舌下") {
      item = arr.find((item: any) => item.name.startsWith("舌下"));
    } else {
      item = arr.find((item: any) => item.name.includes(type));
    }
    console.log(item)
    if (!item || !item.name) {
      this.$message.warning(`${type}量表未配置，请先配置量表`);
      return null;
    }
    const data = await this.getTemplate(item.name);
    data.related_type = '四诊客观化数据';
    // 修改value
    data.data[0].value = {imgs: [img]};
    const res1 = await this.saveTemplate(data);
    // 第二次保存，这里需要处理默认数据
    // 处理默认数据
    const resultData = initData(JSON.parse(JSON.stringify(res1)));
    res = await this.saveContent(resultData);
    return res;
  }

  private goMaizhen() {
    if (this.checkedJianChaListIsEmpty()) {
      return
    }
    if (this.maiZhengCount >= 6) {
      return;
    }
    const type = 'real'; // mock 模拟数据,real 真实数据
    if (type == 'real') {
      const uid = Date.now() + "_" + this.patient.id;
      window.electronMyAPI.launchExe("pulse", uid);
      // 弹出中间弹框
      this.$confirm("是否在设备上采集完成？", "脉诊采集", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        confirmButtonText: "采集完成",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        cancelButtonText: "取消",
      }).then(async () => {
        // 上传脉
        const exeRes = await window.electronMyAPI.uploadPulse(uid);
        // 先获取图片填充到value，然后保存content
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          params: {
            uid: exeRes,
            name: "pulse",
          },
        };
        GetExeImg(this, params, loading).then(async (res: any) => {
          loading.close();
          if (res.code == 2000) {
            // 在newstData中查找包含"脉"的项
            const pulseItem = this.newstData.find((item: any) => item.name && item.name.includes('脉'));
            const name = pulseItem ? pulseItem.name : '';
            const related_type = pulseItem ? pulseItem.related_type : '';
            const data = await this.getTemplate(name);
            data.related_type = related_type;
            // 修改value
            data.data[0].value = res.data.imgs;
            // 修改report
            data.report = res.data.report;
            // 处理默认数据
            const resultData = initData(JSON.parse(JSON.stringify(data)));
            const resContent = await this.saveTemplate(resultData);
            this.getMode3Data();
            this.goRefreshTopData();
            this.getJianchaList();
          } else {
            this.$confirm("对不起，采集失败，请重新采集！", "脉诊采集", {
              customClass: "commonConfirm",
              confirmButtonClass: "iconfont icon-anniu4 confirmSure",
              cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
              confirmButtonText: "重新采集",
              cancelButtonText: "返回",
            })
                .then(() => {
                  this.goMaizhen();
                })
          }
        });
      });
    } else {
      const res = {
        data: {
          imgs: [
            "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
            "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
            "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg"
          ],
          report: {
            pulse_hand: '右手',
            pulse_pos: '尺脉',
            "连续脉图": "",
            "分段压脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
            "最佳压力脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
            "脉象p-h趋势图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg",
            "脉象信息输出": {
              "脉位": "浮",
              "脉力": "有力",
              "脉名": "其它脉",
              "脉率": "慢(71times/min)",
              "流利度": "",
              "紧张度": "",
              "脉节律": "不齐"
            },
            "最佳脉象图参数": {
              "A": 0,
              "t": 0.38,
              "Ad": -5.35326,
              "As": 196.472,
              "h1": 46.0749,
              "h2": 43.1337,
              "h3": 42.9087,
              "h4": 3.07369,
              "h5": -4.37927,
              "t1": 0.172,
              "t2": 0.204,
              "t3": 0.205,
              "t4": 0.308,
              "t5": 0.072,
              "w1": 0.127,
              "w2": 0.087,
              "t1/t": 0.45,
              "w1/t": 0.33,
              "w2/t": 0.23,
              "h3/h1": 0.93,
              "h4/h1": 0.07,
              "h5/h1": -0.1,
              "t5/t4": 0.23
            }
          }
        }
        // data: {
        //   imgs: {
        //     "右脉": [],
        //     "左脉": [
        //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
        //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
        //       "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg"
        //     ]
        //   },
        //   report: {
        //     "右手连续脉图": "",
        //     "左手连续脉图": "",
        //     "右手分段压脉图": "",
        //     "左手分段压脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
        //     "右手最佳压力脉图": "",
        //     "右手脉象p-h趋势图": "",
        //     "右手脉象信息输出": {},
        //     "左手最佳压力脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
        //     "左手脉象p-h趋势图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg",
        //     "左手脉象信息输出": {
        //       "脉位": "浮",
        //       "脉力": "有力",
        //       "脉名": "其它脉",
        //       "脉率": "慢(71times/min)",
        //       "流利度": "",
        //       "紧张度": "",
        //       "脉节律": "不齐"
        //     },
        //     "右手最佳脉象图参数": {},
        //     "左手最佳脉象图参数": {
        //       "A": 0,
        //       "t": 0.38,
        //       "Ad": -5.35326,
        //       "As": 196.472,
        //       "h1": 46.0749,
        //       "h2": 43.1337,
        //       "h3": 42.9087,
        //       "h4": 3.07369,
        //       "h5": -4.37927,
        //       "t1": 0.172,
        //       "t2": 0.204,
        //       "t3": 0.205,
        //       "t4": 0.308,
        //       "t5": 0.072,
        //       "w1": 0.127,
        //       "w2": 0.087,
        //       "t1/t": 0.45,
        //       "w1/t": 0.33,
        //       "w2/t": 0.23,
        //       "h3/h1": 0.93,
        //       "h4/h1": 0.07,
        //       "h5/h1": -0.1,
        //       "t5/t4": 0.23
        //     }
        //   }
        // }

      }
      this.$confirm("是否在设备上采集完成？", "脉诊采集", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        confirmButtonText: "采集完成",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        cancelButtonText: "取消",
      }).then(async () => {
        // 在newstData中查找包含"脉"的项
        const pulseItem = this.newstData.find((item: any) => item.name && item.name.includes('脉'));
        const name = pulseItem ? pulseItem.name : '';
        const related_type = pulseItem ? pulseItem.related_type : '';
        const data = await this.getTemplate(name);
        data.related_type = related_type;
        // 修改value
        data.data[0].value = res.data.imgs;
        // 修改report
        data.report = res.data.report;
        // 处理默认数据
        // const resultData = initData(JSON.parse(JSON.stringify(data)));
        // const resContent = await this.saveTemplate(resultData);
        const resContent = await this.saveTemplate(data);
        this.getMode3Data();
        this.goRefreshTopData();
        this.getJianchaList();
      });
    }

  }

  private goWenzhen() {
    if (this.checkedJianChaListIsEmpty() || (this.wangZhengCount <= 0 && this.maiZhengCount <= 0)) {
      return
    }

    // if (!this.mode3Data['舌'] && !this.mode3Data['面'] && !this.mode3Data['舌下'] && !this.mode3Data['脉']) {
    //   return;
    // }
    const wenData = this.newstData.find((item: any) => item.name.includes('问'));
    if (!wenData) {
      this.$message.warning('问诊量表未配置，请先配置问诊量表');
      return;
    }
    this.$router.push({
      path: "/main/edit-wen",
      query: {
        name: wenData.name,
        related_type: '四诊客观化数据',
      },
    });

  }

  private goZhuanbing() {
    if (this.checkedJianChaListIsEmpty() || (this.maiZhengCount <= 0&&this.wangZhengCount<=0)) {
      return;
    }
    this.ifShowZhuanbing = true;
  }

  private openZhuanbingModule(payload: { path: string; query: Record<string, any> }) {
    this.ifShowZhuanbing = false;
    this.$router.push({
      path: payload.path,
      query: payload.query,
    });
  }

  private async getTemplate(name: any) {
    const params: any = {
      params: {
        name: name,
        page: 1,
        ignore_permissions: "true",
      },
    };
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });

    try {
      const res = await GetTemList(this, params);
      const data: any = {
        template: res.data[0],
        collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        data: res.data[0].fields,
      };
      return data;
    } catch (error) {
      throw error;
    }
  }

  private async saveTemplate(data: any) {
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });

    try {
      const params: any = {
        collect_time: data.collect_time,
        patient: this.patient.id,
        data: data.data,
        template: data.template,
        related_type: data.related_type,
      };
      if (data.report) {
        params.report = data.report;
      }
      const res = await PostCepingContent(this, params);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  private async saveContent(data: any) {
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });

    try {
      const res = await EditContent(this, data.id, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  private async deleteOne(item: any) {
    this.$confirm("确定删除该报告吗？", "提示", {
      customClass: "commonConfirm",
    }).then(async () => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      try {
        const res: any = await DelContent(this, item.id, loading);
        this.$message.success("删除成功");
        this.reportData = {};
        const reportRes = await this.getReportList();
        console.log('报告列表')
        console.log(reportRes);
        if (reportRes.length == 0) {
          this.cTab = {name: "首页"};
          this.goRefreshTopData();
          this.getMode3Data();
        }
        loading.close();
      } catch (error) {
        loading.close();
        throw error;
      }
    });
  }

  private async goRefreshTopData() {
    this.getNewstData();
    this.elseData = await this.getElseData();
    this.$forceUpdate();

  }

  private keyVal(val: any) {
    return GetKey(val);
  }

  private refreshJiancha() {
    this.getJianchaList();
  }

  private goCaiji(item: any) {
    this.$router.push({
      path: "/main/edit-ceping",
      query: {
        name: item.name,
        related_type: item.related_type,
      },
    });
  }

  private goCaiji2(item: any) {
    this.$router.push({
      path: "/main/edit-ceping",
      query: {
        name: item.name,
        related_type: item.related_type,
      },
    });
  }

  private async goElse(name?: any) {
    if (this.checkedJianChaListIsEmpty()) {
      return
    }
    this.elseList = await this.getElseData(name);
    this.ifShowElse = true;
  }

  private openJiancha(val: any) {
    if (!val) {
      this.jianchaQuery = {
        name: "河南检查",
      };
    } else {
      this.jianchaQuery = {
        content_id: val.id,
      };
    }
    this.ifShowJiancha = true;
  }

  private goSinglePrinting(val: any) {
    this.currentJianchaId = val && val.id ? String(val.id) : "";
    this.jianChaStartTime = val.create_datetime
    this.$store.commit("updateBmi", {
      bmi_category: val.bmi_category,
      bmi_value: val.bmi_value,
      height: val.height,
      weight: val.weight
    });

    const currentIndex = this.jianchaList.findIndex((item: any) => item.id === val.id);
    if (currentIndex > 0) {
      this.jianChaEndTime = this.jianchaList[currentIndex - 1].create_datetime;
    } else {
      const now = new Date();
      this.jianChaEndTime = now.getFullYear() + '-' +
          String(now.getMonth() + 1).padStart(2, '0') + '-' +
          String(now.getDate()).padStart(2, '0') + ' ' +
          String(now.getHours()).padStart(2, '0') + ':' +
          String(now.getMinutes()).padStart(2, '0') + ':' +
          String(now.getSeconds()).padStart(2, '0');
    }
    console.log('开始时间:', this.jianChaStartTime);
    console.log('结束时间:', this.jianChaEndTime);
    this.ifShowSinglePrinting = true
  }

  private switchChange(e: any) {
    if (e) {
      // 打开紫外灯
      window.electronMyAPI.changeLight("紫外光-ON");
      this.$store.commit("updateIfShowZiwai", true);
    } else {
      // 关闭紫外灯
      window.electronMyAPI.changeLight("紫外光-OFF");
      this.$store.commit("updateIfShowZiwai", false);
    }
  }

  private async changePatient(e: any) {
    this.cTab = {name: "首页"};
    this.$store.commit("updatePatient", e);
    this.resetData();
    await this.getData();
    this.refreshJiancha();
  }

  private resetData() {
    this.reportList = [];
    this.reportData = {};
  }

  private addPatient() {
    this.$router.push({
      path: "/main/patient/add",
    });
  }

  private goPatient() {
    this.$router.push({
      path: "/main/patient/add",
      query: {
        id: this.patient.id,
      },
    });
  }

  private getNewstData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: "四诊客观化数据",
      },
    };
    GetNewsTems(this, params, loading).then((res: any) => {
      res.data["四诊客观化数据"].forEach((ele: any) => {
        ele.related_type = "四诊客观化数据";
      });
      this.newstData = res.data["四诊客观化数据"];
    });
  }

  private async getElseData(name?: any): Promise<any[]> {
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: "健康测评数据",
        category_names: name,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      const res: any = await GetNewsTems(this, params, loading);
      res.data["健康测评数据"].forEach((ele: any) => {
        ele.related_type = "健康测评数据";
      });
      return res.data["健康测评数据"];
    } catch (error) {
      loading.close();
      throw error;
    }
  }

  private async changeTab(item: any) {
    this.cTab = item;
    this.resetData();
    await this.getData();
  }

  private changeReport(item: any) {
    if (this.ifEdit) {
      this.$confirm("当前编辑内容未保存，是否离开？", "离开", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        confirmButtonText: "离开",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
        cancelButtonText: "取消",
      }).then(async () => {
        this.reportData = item;
        this.ifEdit = false;
      });
    } else {
      this.reportData = item;

    }
  }

  private async getReportList() {
    if (this.cTab.name == '问诊aaa') {
      console.log('问诊数据');
      const wenData = {
        id: '23333333',
        template: {
          "id": 50,
          "name": "问诊",
          "category": [],
          "intro": "",
          "result_rule": [],
          "report_type": {
            "id": 666,
            "label": "问诊报告",
            "value": "wen.cal_report"
          },
          "is_group": false,
          "is_voice": false
        },
        report: {
          suggest: ''
        },
        collect_time: "2025-07-17 09:08:09",
        update_datetime: "2025-07-17 09:08:09",
        patient: {
          "id": 49742,
          "name": "测试11",
          "uid": "369852",
          "birthday": "1986-06-05",
          "age": 39,
          "phone_number": "18800000000",
          "gender": {
            "id": 629,
            "label": "男",
            "value": "1"
          },
          "create_datetime": "2025-06-20 11:23:32"
        },
        "主诉": [
          "有头痛、头晕；或失眠，心悸；或胸闷、心慌",
          "有肠胃病症；胃口不好；口苦口干；腹泻；大便不好"
        ],
        "主症": {
          "name": "全身肌肉酸痛"
        },
        "舌面脉": {
          "舌": {
            "id": 50,
            "name": "舌诊采集",
            "category": null,
            "intro": "",
            "result_rule": null,
            "report_type": null,
            "collect_time": "2025-07-17 09:08:00",
            "content_id": 4283361,
            "result": "淡紫,有,有,苔黄,厚,有,无,无,适中,无,有,有",
            "score": "https://gyhl.oss-cn-shanghai.aliyuncs.com/tongue-ai/399dbad7-c809-49c8-9e9c-70a66be92327_segment.jpg",
            "report": {
              "content_data": [
                {
                  "id": "1743342680691",
                  "hide": false,
                  "type": "舌象80",
                  "value": {
                    "imgs": [
                      {
                        "id": 3214,
                        "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125322.jpg",
                        "name": "125322.jpg",
                        "size": "60420",
                        "engine": "oss",
                        "md5sum": "58df3c1df9854a1eaf83f171f52d3c41",
                        "creator": 39,
                        "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/125322.jpg",
                        "modifier": "39",
                        "mime_type": "image/jpeg",
                        "description": null,
                        "creator_name": "河南四诊",
                        "modifier_name": "河南四诊",
                        "dept_belong_id": 16,
                        "create_datetime": "2025-07-16 09:47:38",
                        "update_datetime": "2025-07-16 09:47:38"
                      },
                      {
                        "id": 3241,
                        "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/e7a50197-cd8e-40c7-80b7-44257fb23761_segment.jpg",
                        "name": "e7a50197-cd8e-40c7-80b7-44257fb23761_segment.jpg",
                        "size": "116105",
                        "engine": "oss",
                        "md5sum": "6384150a4150749bfbf516e85b5cd801",
                        "creator": null,
                        "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/e7a50197-cd8e-40c7-80b7-44257fb23761_segment.jpg",
                        "modifier": null,
                        "mime_type": "image/jpeg",
                        "description": "舌象分割后图片",
                        "creator_name": null,
                        "modifier_name": null,
                        "dept_belong_id": null,
                        "create_datetime": "2025-07-17 09:08:01",
                        "update_datetime": "2025-07-17 09:08:01"
                      }
                    ]
                  },
                  "img_num": 1,
                  "video_num": 1,
                  "support_img": true,
                  "support_devices": true,
                  "support_take_photos": false,
                  "support_take_photos_whitelight": false
                }
              ],
              "舌色参数": [
                [
                  56.4,
                  57.06,
                  54.76,
                  57.12,
                  56.19,
                  56.87
                ],
                [
                  19.63,
                  19.89,
                  18.28,
                  19.61,
                  19.56,
                  20.82
                ],
                [
                  7.37,
                  6.53,
                  8.01,
                  7.72,
                  7.87,
                  6.74
                ],
                [
                  "淡紫",
                  "",
                  "",
                  "",
                  "",
                  ""
                ]
              ],
              "舌象信息": {
                "舌形": [
                  [
                    "有瘀斑瘀点",
                    "适中",
                    "有点刺",
                    "有裂纹"
                  ],
                  []
                ],
                "舌态": [
                  [
                    "正常"
                  ],
                  []
                ],
                "舌神": [
                  [
                    "荣"
                  ],
                  []
                ],
                "舌色": [
                  [
                    "淡紫"
                  ],
                  [
                    "边尖红"
                  ]
                ],
                "苔色": [
                  [
                    "苔黄"
                  ],
                  []
                ],
                "苔质": [
                  [
                    "厚",
                    "腻"
                  ],
                  []
                ]
              },
              "舌象照片": {
                "分割前图片": "https://gyhl.oss-cn-shanghai.aliyuncs.com/tongue-ai/e7a50197-cd8e-40c7-80b7-44257fb23761_crop.jpg",
                "分割后图片": "https://gyhl.oss-cn-shanghai.aliyuncs.com/tongue-ai/e7a50197-cd8e-40c7-80b7-44257fb23761_segment.jpg"
              },
              "苔色参数": [
                [
                  57.8,
                  58.47,
                  56.52,
                  58.91,
                  57.88,
                  57.23
                ],
                [
                  19.22,
                  20.17,
                  17.89,
                  19.23,
                  19.02,
                  19.77
                ],
                [
                  7.69,
                  7.33,
                  7.97,
                  8.21,
                  8.12,
                  6.82
                ],
                [
                  "苔黄",
                  "",
                  "",
                  "",
                  "",
                  ""
                ]
              ],
              "舌象信息输出": [
                "淡紫",
                "有",
                "有",
                "苔黄",
                "厚",
                "有",
                "无",
                "无",
                "适中",
                "无",
                "有",
                "有"
              ]
            },
            "template_data": [
              {
                "id": "1743342680691",
                "hide": false,
                "type": "舌象80",
                "value": {
                  "imgs": []
                },
                "img_num": 1,
                "video_num": 1,
                "support_img": true,
                "support_devices": true,
                "support_take_photos": false,
                "support_take_photos_whitelight": false
              }
            ]
          },
          "面": {
            "id": 51,
            "name": "面诊采集",
            "category": null,
            "intro": "",
            "result_rule": null,
            "report_type": null,
            "collect_time": "2025-07-17 09:08:05",
            "content_id": 4283362,
            "result": "红黄隐隐，明润含蓄,无,无,少量光泽,红",
            "score": "",
            "report": {
              "content_data": [
                {
                  "id": "1743342832339",
                  "hide": false,
                  "type": "面象15",
                  "value": {
                    "imgs": [
                      {
                        "id": 3217,
                        "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/20230914155607.png",
                        "name": "20230914155607.png",
                        "size": "405132",
                        "engine": "oss",
                        "md5sum": "e19c6b987a948abee98fdbd90d4423fe",
                        "creator": 39,
                        "file_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/20230914155607.png",
                        "modifier": "39",
                        "mime_type": "image/png",
                        "description": null,
                        "creator_name": "河南四诊",
                        "modifier_name": "河南四诊",
                        "dept_belong_id": 16,
                        "create_datetime": "2025-07-16 09:48:41",
                        "update_datetime": "2025-07-16 09:48:41"
                      }
                    ]
                  },
                  "img_num": 1,
                  "support_img": true,
                  "support_devices": true,
                  "support_take_photos": false
                }
              ],
              "面象信息": {
                "唇态": [
                  "润"
                ],
                "唇色": [
                  "红"
                ],
                "面色": [
                  "红黄隐隐，明润含蓄",
                  "少量光泽"
                ],
                "鼻光泽": [
                  "有光泽"
                ],
                "鼻形态": [
                  "正常"
                ],
                "鼻颜色": [
                  "正常肤"
                ],
                "人中形态": [
                  "短浅"
                ],
                "人中颜色": [
                  "正常肤色"
                ]
              },
              "面象照片": {
                "分割前图片": "",
                "分割后图片": ""
              },
              "面色唇色参数": [
                [
                  "151.914",
                  "182.662",
                  "198.327",
                  "194.874",
                  "165.141",
                  "195.453",
                  "169.773"
                ],
                [
                  "129.666",
                  "129.182",
                  "129.765",
                  "130.016",
                  "130.051",
                  "129.779",
                  "133.192"
                ],
                [
                  "132.659",
                  "133.75",
                  "134.63",
                  "135.031",
                  "134.833",
                  "136.228",
                  "136.059"
                ],
                [
                  "红黄隐隐，明润含蓄",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "红"
                ]
              ],
              "面象信息输出": [
                "红黄隐隐，明润含蓄",
                "无",
                "无",
                "少量光泽",
                "红"
              ]
            },
            "template_data": [
              {
                "id": "1743342832339",
                "hide": false,
                "type": "面象15",
                "value": {
                  "imgs": []
                },
                "img_num": 1,
                "support_img": true,
                "support_devices": true,
                "support_take_photos": false
              }
            ]
          },
          "舌下": {
            "id": 53,
            "name": "舌下采集",
            "category": null,
            "intro": "",
            "result_rule": null,
            "report_type": null,
            "collect_time": "2025-07-17 09:08:10",
            "content_id": 4283363,
            "result": "",
            "score": "",
            "report": {
              "舌底信息": {
                "形态": "双支",
                "粗细": "正常",
                "长度": "正常",
                "颜色": "淡红含浅蓝"
              }
            },
            "template_data": [
              {
                "id": "1743344482781",
                "hide": false,
                "type": "舌底",
                "value": {
                  "imgs": []
                },
                "img_num": 1,
                "support_img": true,
                "support_devices": true
              }
            ]
          },
          "脉": {
            "id": 52,
            "name": "脉诊采集",
            "category": null,
            "intro": "",
            "result_rule": null,
            "report_type": null,
            "collect_time": "2025-07-17 09:12:30",
            "content_id": 4283364,
            "result": "",
            "score": "",
            "report": {
              "右手连续脉图": "",
              "左手连续脉图": "",
              "右手分段压脉图": "",
              "左手分段压脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
              "右手最佳压力脉图": "",
              "右手脉象p-h趋势图": "",
              "右手脉象信息输出": {},
              "左手最佳压力脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
              "左手脉象p-h趋势图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg",
              "左手脉象信息输出": {
                "脉位": "浮",
                "脉力": "有力",
                "脉名": "大脉",
                "脉率": "慢(71times/min)",
                "流利度": "",
                "紧张度": "",
                "脉节律": "不齐"
              },
              "右手最佳脉象图参数": {},
              "左手最佳脉象图参数": {
                "A": 0,
                "t": 0.38,
                "Ad": -5.35326,
                "As": 196.472,
                "h1": 46.0749,
                "h2": 43.1337,
                "h3": 42.9087,
                "h4": 3.07369,
                "h5": -4.37927,
                "t1": 0.172,
                "t2": 0.204,
                "t3": 0.205,
                "t4": 0.308,
                "t5": 0.072,
                "w1": 0.127,
                "w2": 0.087,
                "t1/t": 0.45,
                "w1/t": 0.33,
                "w2/t": 0.23,
                "h3/h1": 0.93,
                "h4/h1": 0.07,
                "h5/h1": -0.1,
                "t5/t4": 0.23
              }
            },
            "template_data": [
              {
                "id": "1743342937916",
                "hide": false,
                "type": "脉象",
                "value": {},
                "support_devices": true
              }
            ]
          }
        },
        "综合": {
          "刻下症": [
            {
              "name": "鼻痒"
            },
            {
              "name": "打喷嚏"
            },
            {
              "name": "失眠"
            },
            {
              "name": "呼吸不畅"
            },
            {
              "name": "流鼻涕"
            },
            {
              "name": "鼻塞"
            },
            {
              "name": "抽搐"
            },
            {
              "name": "耳鸣"
            },
            {
              "name": "鼻涕带血"
            }
          ],
          "中医疾病": [
            {
              "name": "流鼻涕"
            },
            {
              "name": "失眠"
            },
            {
              "name": "鼻痒"
            },
            {
              "name": "呕吐腹泻"
            },
            {
              "name": "全身肌肉酸痛"
            },
            {
              "name": "寒战"
            },
            {
              "name": "耳鸣"
            }
          ],
          "中医证型": [
            {
              "name": "流鼻涕"
            },
            {
              "name": "呼吸不畅"
            },
            {
              "name": "失眠"
            },
            {
              "name": "呕吐腹泻"
            },
            {
              "name": "全身肌肉酸痛"
            },
            {
              "name": "鼻痒"
            },
            {
              "name": "鼻涕带血"
            },
            {
              "name": "发热"
            }
          ],
          "中药方剂": [
            {
              "name": "流鼻涕"
            },
            {
              "name": "失眠"
            },
            {
              "name": "鼻涕带血"
            },
            {
              "name": "全身肌肉酸痛"
            },
            {
              "name": "呕吐腹泻"
            },
            {
              "name": "寒战"
            },
            {
              "name": "耳鸣"
            }
          ],
          "中药组成": [
            {
              "name": "人参",
              "quantity": "2"
            },
            {
              "name": "紫苏叶",
              "quantity": "6"
            },
            {
              "name": "葛根",
              "quantity": "5"
            },
            {
              "name": "前胡",
              "quantity": "3"
            },
            {
              "name": "半夏",
              "quantity": "4"
            },
            {
              "name": "茯苓",
              "quantity": "5"
            }
          ],
          "用法用量": "每日1剂分两次服用，共14剂。"
        }
      };
      this.reportList = [wenData];
      this.reportData = wenData;
      return this.reportData;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        related_type: this.cTab.related_type,
        page: 1,
        patient_id: this.patient.id,
        limit: 200,
        has_report_type: true,
      },
    };
    if (
        this.cTab.name == "成人" ||
        this.cTab.name == "老年" ||
        this.cTab.name == "女性" ||
        this.cTab.name == "儿童" ||
        this.cTab.name == "慢病"
    ) {
      // params.params.template_name = this.cTab.name;
    } else if (this.cTab.name == "其它") {
    } else {
      params.params.template_name = this.cTab.name;
    }
    try {
      const res: any = await GetContentList(this, params, loading);
      this.reportList = res.data;
      if (!this.reportData.id && res.data.length > 0) {
        this.reportData = this.reportList[0];
      }
      return this.reportList;
    } catch (error) {
      loading.close();
      throw error;
    }
  }

  private getJianchaList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        page: 1,
        patient_id: this.patient.id,
        limit: 200,
        template_name: "河南检查",
      },
    };
    this.$store.commit("updateBmi", {});
    GetContentList(this, params, loading).then((res: any) => {
      this.jianchaList = res.data;
      let item = this.jianchaList[0];
      this.currentJianchaId = item && item.id ? String(item.id) : "";

      this.jianChaStartTime = item.create_datetime
      const currentIndex = this.jianchaList.findIndex((it: any) => it.id === item.id);
      if (currentIndex > 0) {
        this.jianChaEndTime = this.jianchaList[currentIndex - 1].create_datetime;
      } else {
        const now = new Date();
        this.jianChaEndTime = now.getFullYear() + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            String(now.getDate()).padStart(2, '0') + ' ' +
            String(now.getHours()).padStart(2, '0') + ':' +
            String(now.getMinutes()).padStart(2, '0') + ':' +
            String(now.getSeconds()).padStart(2, '0');
      }
      console.log('开始时间:', this.jianChaStartTime);
      console.log('结束时间:', this.jianChaEndTime);
      if (item != null) {
        this.$store.commit("updateBmi", {
          bmi_category: item.bmi_category,
          bmi_value: item.bmi_value,
          height: item.height,
          weight: item.weight
        });
      }

      this.getLastJianChaAllReportList(this.jianChaStartTime, this.jianChaEndTime);
    });
  }

  private async getData() {
    if (this.cTab.name == "首页") {
      this.getNewstData();
      this.getJianchaList();
      if (this.systemInfo.SETTING.mode == 'tizhi') {
        this.elseData = await this.getElseData();
      }
      if (this.systemInfo.SETTING.mode == 'bianzheng') {
        this.getMode3Data();
      }
    } else {
      await this.getReportList();
    }
  }

  private changeData(e: any, index: any) {
    console.log('changeData');
    console.log(e);
    console.log(index);
    this.reportData = e;
    this.$forceUpdate();
  }

  private updateBannerSize() {
    this.$nextTick(() => {
      const homeContent = document.querySelector(".home-content");
      if (homeContent) {
        const width = homeContent.getBoundingClientRect().width;
        this.bannerWidth = `${width}px`;
        this.bannerHeight = `${(width * 500) / 1200}px`;
      }
    });
  }

  private refreshPatientListPanel() {
    const patientListRef: any = (this.$refs as any).patientListRef;
    if (patientListRef && typeof patientListRef.refreshList === "function") {
      patientListRef.refreshList();
    }
  }

  private async handleScanConfirm(payload: CepingScanPayload) {
    const res = await syncPatientAndCreateCheckByScan(this, payload);
    await autoCreateTizhiContentByScanAnswer(this, res.patient.id, payload.answers);
    this.$store.commit("updateBmi", {
      height: payload.height || "",
      weight: payload.weight || "",
    });
    await this.changePatient(res.patient);
    this.$nextTick(() => this.refreshPatientListPanel());
    this.$message.success("患者信息已同步，并自动新建检查");
  }

  private async mounted() {
    this.updateBannerSize();
    window.addEventListener("resize", this.updateBannerSize);
    if (this.systemInfo.SETTING.enableScanner){
      this.homeScanListener = new HomeCepingScanListener(
          this as any,
          this.handleScanConfirm.bind(this)
      );
      this.homeScanListener.start();
    }
    if (this.patient.id) {
      await this.getData();
    }
  }

  private beforeDestroy() {
    window.removeEventListener("resize", this.updateBannerSize);
    if (this.homeScanListener) {
      this.homeScanListener.stop();
      this.homeScanListener = null;
    }
  }
}
